import zip from 'lodash-es/zip';
import { computed } from 'mobx';
import ColorStrings from 'owa-color-picker/lib/utils/Colors.locstring.json';
import loc from 'owa-localize';
import {
    darkModeTextColors,
    lightModeTextColors,
    lightModeBackColors,
    darkModeBackColors,
} from 'owa-color-constants';

const textColorNames = [
    ColorStrings.lightBlueColor,
    ColorStrings.lightGreenColor,
    ColorStrings.lightYellowColor,
    ColorStrings.lightOrangeColor,
    ColorStrings.lightRedColor,
    ColorStrings.lightPurpleColor,
    ColorStrings.blueColor,
    ColorStrings.greenColor,
    ColorStrings.yellowColor,
    ColorStrings.orangeColor,
    ColorStrings.redColor,
    ColorStrings.purpleColor,
    ColorStrings.darkBlueColor,
    ColorStrings.darkGreenColor,
    ColorStrings.darkYellowColor,
    ColorStrings.darkOrangeColor,
    ColorStrings.darkRedColor,
    ColorStrings.darkPurpleColor,
    ColorStrings.darkerBlueColor,
    ColorStrings.darkerGreenColor,
    ColorStrings.darkerYellowColor,
    ColorStrings.darkerOrangeColor,
    ColorStrings.darkerRedColor,
    ColorStrings.darkerPurpleColor,
    ColorStrings.whiteColor,
    ColorStrings.lightGrayColor,
    ColorStrings.grayColor,
    ColorStrings.darkGrayColor,
    ColorStrings.darkerGrayColor,
    ColorStrings.blackColor,
];

const backColorNames = [
    ColorStrings.cyanColor,
    ColorStrings.greenColor,
    ColorStrings.yellowColor,
    ColorStrings.orangeColor,
    ColorStrings.redColor,
    ColorStrings.magentaColor,
    ColorStrings.lightCyanColor,
    ColorStrings.lightGreenColor,
    ColorStrings.lightYellowColor,
    ColorStrings.lightOrangeColor,
    ColorStrings.lightRedColor,
    ColorStrings.lightMagentaColor,
    ColorStrings.whiteColor,
    ColorStrings.lightGrayColor,
    ColorStrings.grayColor,
    ColorStrings.darkGrayColor,
    ColorStrings.darkerGrayColor,
    ColorStrings.blackColor,
];

export interface ColorCode {
    lightModeColor: string;
    darkModeColor: string;
}

let textColorCells = computed(() => {
    return zip(textColorNames, lightModeTextColors).map(
        ([textColorNames, lightModeTextColors]) => ({
            id: textColorNames!,
            color: lightModeTextColors!,
            label: loc(textColorNames!),
        })
    );
});
export const getTextColorCells = () => textColorCells.get();

let backColorCells = computed(() => {
    return zip(backColorNames, lightModeBackColors).map(
        ([backColorNames, lightModeBackColors]) => ({
            id: backColorNames!,
            color: lightModeBackColors!,
            label: loc(backColorNames!),
        })
    );
});
export const getBackColorCells = () => backColorCells.get();

let textColors = computed(() => {
    const textColorsSet = {};
    zip(textColorNames, lightModeTextColors, darkModeTextColors).forEach(
        ([textColorNames, lightModeTextColors, darkModeTextColors]) => {
            const colorCode: ColorCode = {
                lightModeColor: lightModeTextColors!,
                darkModeColor: darkModeTextColors!,
            };
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (104,13): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            // @ts-expect-error
            textColorsSet[textColorNames!] = colorCode;
        }
    );
    return textColorsSet;
});
export { textColors };

let backColors = computed(() => {
    const backColorsSet = {};
    zip(backColorNames, lightModeBackColors, darkModeBackColors).forEach(
        ([backColorNames, lightModeBackColors, darkModeBackColors]) => {
            const colorCode: ColorCode = {
                lightModeColor: lightModeBackColors!,
                darkModeColor: darkModeBackColors!,
            };
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (122,13): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            // @ts-expect-error
            backColorsSet[backColorNames!] = colorCode;
        }
    );
    return backColorsSet;
});
export { backColors };

export function getTextColorCode(colorId: string): ColorCode {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (133,12): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    // @ts-expect-error
    return textColors.get()[colorId];
}

export function getBackColorCode(colorId: string): ColorCode {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (140,12): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    // @ts-expect-error
    return backColors.get()[colorId];
}
